import * as yup from "yup";
import { ThermostatAction } from "../generated/graphqlTypes";
export var ThermostatConfigurationSchema;
(function (ThermostatConfigurationSchema) {
    ThermostatConfigurationSchema.Actions = [ThermostatAction.Heat, ThermostatAction.Cool, ThermostatAction.Circulate];
    ThermostatConfigurationSchema.ThresholdRange = { min: 0.5, max: 5 };
    ThermostatConfigurationSchema.CadenceRange = { min: 30, max: 3600 };
    ThermostatConfigurationSchema.Schema = yup.object().shape({
        id: yup.string().required(),
        name: yup.string().required(),
        streamName: yup
            .string()
            .required()
            .matches(/^[a-zA-Z\d]+$/),
        availableActions: yup.array().of(yup.string().oneOf(ThermostatConfigurationSchema.Actions)),
        externalSensorId: yup
            .string()
            .notRequired()
            .nullable()
            .matches(/^$|^[a-f0-9]{16}$/),
        timezone: yup
            .string()
            .notRequired()
            .nullable(),
        threshold: yup
            .number()
            .min(ThermostatConfigurationSchema.ThresholdRange.min)
            .max(ThermostatConfigurationSchema.ThresholdRange.max),
        cadence: yup
            .number()
            .integer()
            .min(ThermostatConfigurationSchema.CadenceRange.min)
            .max(ThermostatConfigurationSchema.CadenceRange.max),
    });
})(ThermostatConfigurationSchema || (ThermostatConfigurationSchema = {}));
//# sourceMappingURL=ThermostatConfigurationSchema.js.map